module.exports = __webpack_public_path__ + "static/media/Brisanje.f95a1e53.JPG";